/**
 * 桥段-跨-幅-梁号；任一段为空则不参与拼接（无左右幅时即为 桥段-跨-梁号）。
 * 跨优先 crossCode，否则 crossName；幅优先 leftRightAmplitude，否则 beamLrType。
 * @param {Record<string, unknown>|null|undefined} item 梁或列表行对象
 * @returns {string} 无有效段时为 '-'
 */
export function formatBeamTitle (item) {
  if (!item) return '-'
  const seg = (v) => {
    if (v == null) return null
    const s = String(v).trim()
    return s.length ? s : null
  }
  const cross = seg(item.crossCode) || seg(item.crossName)
  const lr = seg(item.leftRightAmplitude) || seg(item.beamLrType)
  const parts = [seg(item.bridgeName), cross, lr, seg(item.beamCode)].filter(Boolean)
  return parts.length ? parts.join('-') : '-'
}

/** 关联工序展示：工序标识 + 名称 */
export function procedureDisplayFromCheckRow (row) {
  if (!row) return ''
  const label = row.procedureLabel != null ? String(row.procedureLabel).trim() : ''
  const name = (row.procedureLabelName || row.procedureName || '').trim()
  if (label && name) return `${label} ${name}`
  return name || label || ''
}

/**
 * 报检/验收页「关联工序」只读：优先工序名称字段，再兜底标识+名称拼接
 */
export function procedureNameFromCheckRow (row) {
if (!row) return ''
  const nameCore = String(row.procedureName || '').trim()
  const labelName = String(row.procedureLabelName || '').trim()
  return nameCore || labelName || procedureDisplayFromCheckRow(row)
}
